/* eslint-disable no-param-reassign, class-methods-use-this, no-undef */
class PerformanceHelper {
  /**
   * Executes a function after the DOM load event. If the DOM load event has already taken place,
   * we execute the function immediately.
   *
   * @param func  Non-null function to call on DOMContentLoaded (or onload) event
   * @param arg   Nullable argument to pass to the function
   */
  executeFunctionOnLoad(func, arg) {
    if (!document.readyState || document.readyState === 'complete') {
      console.log('DOM content loaded event has already been fired. Calling func for robustness.');
      func(arg);
      return;
    }

    if (document.addEventListener) {
      document.addEventListener(
        'DOMContentLoaded',
        function() {
          func(arg);
        },
        false
      );
    } else {
      window.attachEvent('onload', function() {
        func(arg);
      });
    }
  }

  /**
   * Report the time since load timing to Gusto Analytics
   * @returns {null|{href: string, loadInMS: number}|{href: string, loadInMS: number, downlink: number, rtt: number, effectiveType: string}}
   */
  getPageLoadInformation() {
    let pageLoadTimeInfo = null;
    let timeSinceLoadInMS = 0;

    // Detects Navigation Timing API support and tracks time since load in MS
    if (window.performance) {
      timeSinceLoadInMS = Math.round(performance.now());
    }
    if (timeSinceLoadInMS > 0) {
      pageLoadTimeInfo = {
        href: window.location.href,
        loadInMS: timeSinceLoadInMS,
      };
    }

    if (pageLoadTimeInfo == null) {
      return null;
    }

    // Add network information
    let connection = null;
    if (navigator) {
      connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    }

    if (connection) {
      pageLoadTimeInfo.downlink = connection.downlink;
      pageLoadTimeInfo.rtt = connection.rtt;
      pageLoadTimeInfo.effectiveType = connection.effectiveType;
    }

    return pageLoadTimeInfo;
  }
}

export default PerformanceHelper;
